import * as React from 'react'
import Errors from './errors'
import Description from './description'
import FormGroup from './form-group'
import InputLabel from './input-label'
import statusActions from '../modules/status/status-actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { keys, map } from 'lodash'

import './selection-input.css'


class SelectionInput extends React.Component<any, any>{

    onHelpClick(e){
        this.props.actions.showMessage(null, this.props.help, null);
    }


    render(){
        const props = this.props;
        const field = props.field;
        const label = props.label;
        const errors = props.errors;
        const value = props.value;
        const description = props.description;
        const updateField = props.updateField;
        const options = props.options;
        const inline = props.inline || false;
        const placeholder = this.props.placeholder;
        const show = props.show;
        const help = this.props.help

        if(show == null || show){
            return (
                <div className={"selection-input col-12" + (!inline ? " col-sm-6" : "")} id={field}>
                    <FormGroup field={ field } errors={ errors } >
                        <div className={"row" + (inline ? " d-flex align-items-center" : "")}>
                            <div className={ inline ? "col-12 col-sm-6" : "col-12"}>
                                <InputLabel field={ field } label={ label } />
                            </div>
                            <div className={ "input-group " + (inline ? "col-12 col-sm-6" : "col-12") + (help ? " no-border-right" : "") }>
                                <select
                                    required
                                    className="form-control"
                                    id={field}
                                    value={value}
                                    onChange={e => updateField(field, e.target.value)}
                                >   
                                    { placeholder 
                                        ? <option className="option-optional" value="" disabled selected hidden>{ placeholder }</option> 
                                        : <option value="" disabled selected hidden>{ placeholder }</option> 
                                    }
                                    
                                { map(options,  option => <option key={ field + "-" + option.description } value={option.value}>{ option.description }</option> ) }
                                </select>

                                { help && 
                                    <span className="input-group-addon cursor-pointer" onClick={ this.onHelpClick.bind(this) } >
                                        <i className="fa fa-lg fa-question-circle-o"aria-hidden="true"></i>
                                    </span> 
                                }

                            </div>
                        </div>
                        <Errors errors={errors}/>
                        <Description description={ description } />
                    </FormGroup>
                </div>
            )
        }else{
            return null;
        }
    }

}





const mapStateToProps = (state) => ({
    
})


const mapDispatchToProps = dispatch => ({
    actions: {
        ...bindActionCreators({
            ...statusActions,
        }, dispatch)
    }
})



export default connect(mapStateToProps, mapDispatchToProps)(SelectionInput)

    


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/selection-input.tsx